import Socketio from 'socket.io-client';
import Store from '../store'


var socket = (room) => {
  return Socketio(process.env.VUE_APP_BASE_URL, {
    query: {
      token: Store.state.user.accessToken
    }
  });
}

const socketObject = {
  socket: socket//,
  // connect: (socket) => {
  //     socket.connect();
  // },
  // disconnect: (socket) => {
  //     socket.disconnect();
  // }
}
//const SocketInstance = Socketio(process.env.VUE_APP_BASE_URL + 'api/rooms/dockets');
//const SocketInstance = Socketio('http://149.28.170.106');

//Vue.use(VueSocketio, SocketInstance);


export default socketObject;
//export default SocketInstance;